import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import {DISABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class AppVersionTask extends AbstractRequestTask {

  getUrl() {
    return `${getAppConfig().end_point_middleware}check-app-version`;
  }

  isValid(data) {

  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return DISABLE_MODAL_RETRIES;
  }
  
  parseErrors(err) {
    console.log('Parser errors en appVersion');
  }

  isValid(data) {
    return data;
  }


}

export default AppVersionTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/application/AppVersionTask.js